// settingsApi — read/write GLOBAL app settings (assistant on/off, maintenance
// banner) via the settings service, so a super-admin change applies to all
// users without republishing config.json.
//
// Base URL: VITE_SETTINGS_URL, else VITE_AGENT_URL (the EIX-COPILOT backend,
// which serves GET/PUT /settings). Blank → no settings backend: the app falls
// back to config.json / env / on-device preview (see appConfig.js).

const BASE = (import.meta.env.VITE_SETTINGS_URL || import.meta.env.VITE_AGENT_URL || '').replace(/\/$/, '');

export const settingsBackendEnabled = () => Boolean(BASE);

const token = () => localStorage.getItem('sendero_token') || '';

/** GET the global settings. Returns the object, or null if unreachable/disabled. */
export async function fetchAppSettings(signal) {
    if (!BASE) return null;
    try {
        const res = await fetch(`${BASE}/api/provider/admin/getAppSettings`, { signal, cache: 'no-store' });
        //return res.ok ? await res.json() : null;

        
            const data = await res.json();

            //console.log("JSON settingsAPI:", data.Data);
            //console.log("JSON settingsAPI string:", JSON.stringify(data));

            //return data;
            return res.ok ? data.Data : null;
        
        

        
    } catch { return null; }
}

/** PUT a settings patch (super-admin). Returns the updated settings; throws on error. */
export async function saveAppSettings(patch, signal) {
    //console.log("saveAppSettings PATCH : " + JSON.stringify(patch));
    if (!BASE) throw new Error('No settings service configured (set VITE_SETTINGS_URL or VITE_AGENT_URL).');
  //  const res = await fetch(`${BASE}/settings`, {
    const res = await fetch(`${BASE}/api/provider/admin/updateAppSettings`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...(token() ? { Authorization: `Bearer ${token()}` } : {}) },
        body: JSON.stringify(patch),        
        signal,
    });
    const data = await res.json();
    if (!res.ok) {
        
        let detail = '';
        try { detail = (await res.json())?.error || ''; } catch { /* ignore */ }
        throw new Error(`${res.status} ${res.statusText}${detail ? ` — ${detail}` : ''}`);
    }
    
    
    return res.ok ? data.Data : null;
    //return res.json();
}
